import React, { useCallback, useContext, useEffect, useState } from 'react'

import LiveSelect from 'live/components/forms/ui/select'
import { WidgetEditorContext } from 'live/context/widget-editor'
import { jsonResponseExtractor, memoizeByTime } from 'live/lib/utils'
import i18n from 'live/services/i18n'

import { ASSET_LOOKUP } from '../../../utils/constants'

type WellSelectorProps = {
    changeConfig: (field: string, value: string) => void
    widgetConfig: LiveWidgetConfig<ImageLogConfig>
    isEditor: boolean
    value: string
}

const getWells = memoizeByTime(() => fetch('/services/plugin-wells/wells').then(jsonResponseExtractor), 5 * 60 * 1000)

const WellSelector = (props: WellSelectorProps): React.ReactElement => {
    const { actions } = useContext(WidgetEditorContext)

    const [wells, setWells] = useState([])

    const updateFilter = useCallback(
        value => {
            actions?.updateFilter('lookupValues', { [ASSET_LOOKUP]: value })
            actions?.testFilters()
        },
        [actions]
    )

    useEffect(() => {
        getWells().then(setWells)
    }, [])

    useEffect(() => {
        if (!props.value && wells.length > 0) {
            updateFilter(wells[0].name)
        }
    }, [wells, props.value, updateFilter])

    return (
        <LiveSelect
            label={i18n('Test well')}
            options={wells.map(well => ({ label: well.name, value: well.name }))}
            value={props.value}
            placeholder={i18n('Select well')}
            onChange={updateFilter}
            clearable={false}
        />
    )
}

export default WellSelector
